/** Campos — Informe de Evaluación y Plan (Integración Sensorial / SP-2) */

export const TIPO_CAMPO = {
  LINEA: "linea",
  MULTILINEA: "multilinea",
  FECHA: "fecha",
};

export const CAMPOS_DATOS_GENERALES = [
  { key: "nombreApellido", label: "Nombre y apellido", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "fnacimiento", label: "Fecha de nacimiento", tipo: TIPO_CAMPO.FECHA },
  { key: "edadTexto", label: "Edad", tipo: TIPO_CAMPO.LINEA, maxLength: 25 },
  { key: "centroEducativo", label: "Centro educativo", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "diagnostico", label: "Diagnóstico", tipo: TIPO_CAMPO.LINEA, maxLength: 100 },
  { key: "nombreTerapeuta", label: "Terapeuta", tipo: TIPO_CAMPO.LINEA, maxLength: 80 },
  { key: "fechaEvaluacion", label: "Fecha de evaluación", tipo: TIPO_CAMPO.FECHA },
  { key: "fechaInforme", label: "Fecha de informe", tipo: TIPO_CAMPO.FECHA },
];

export const CAMPOS_SECCIONES = [
  { key: "motivoReferencia", label: "Motivo de referencia", rows: 4 },
  { key: "antecedentesRelevantes", label: "Antecedentes relevantes", rows: 4 },
  { key: "instrumentosUtilizados", label: "Instrumentos utilizados", rows: 3 },
  { key: "metodosEvaluacion", label: "Los métodos de evaluación incluyeron", rows: 4 },
  { key: "observacionClinica", label: "Observación clínica en terapia", rows: 5 },
  { key: "resultadosPerfilSensorial", label: "Resultados del Perfil Sensorial", rows: 6 },
  { key: "conclusion", label: "Conclusión", rows: 5 },
  { key: "planIntervencion", label: "Plan de intervención", rows: 5 },
  { key: "objetivosIntervencion", label: "Objetivos de intervención", rows: 5 },
  { key: "recomendaciones", label: "Recomendaciones", rows: 5 },
  { key: "sugerencias", label: "Sugerencias", rows: 4 },
  { key: "dietaSensorial", label: "Dieta sensorial para la casa y escuela", rows: 5 },
];
